import { ApiRef, createApiRef } from '@backstage/core-plugin-api';

export const utilityApiRef: ApiRef<UtilityApi> = createApiRef<UtilityApi>({
  id: 'plugin.aiecosystem-utility.api',
});

export interface UtilityApi {
  /**
   * Checks if a name is available for a given resource type
   * @param name - The name to check
   * @param type - The type of resource (e.g., 'agent', 'mcp_server')
   * @param excludeId - Optional ID to exclude from the check (useful for updates)
   * @returns Promise resolving to an object with 'available' boolean
   */
  getNameAvailability(
    name: string,
    type: string,
    excludeId?: string,
  ): Promise<{ available: boolean }>;
}
